import type { TFunction } from 'i18next'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import IconForum from '@/shared/icons/NewDesign/IconForum'
import IconInfo from '@/shared/icons/NewDesign/IconInfo'
import IconSchool from '@/shared/icons/NewDesign/IconSchool'
import ObjectionList from './ObjectionList'
import ProductBrief from './ProductBrief'
import ResourceList from './ResourceList'
import SalePanel from './SalePanel'
import type { SaleResource } from './types'
import useSalePanels from './useSalePanels'
import { PanelStack } from './styled-components'

interface SalePanelsProps {
  t: TFunction
  saleType: string
  resources: SaleResource[]
  values: Record<string, string>
  highlightedValues: Record<string, string>
}

const SalePanels = ({ t, saleType, resources, values, highlightedValues }: SalePanelsProps) => {
  const { panels, objections, resourceItems, brief, rules, hasRules, note, resourceModal, closeResource } =
    useSalePanels({ t, saleType, resources, values, highlightedValues })

  return (
    <PanelStack>
      <SalePanel panel={panels.objections} icon={<IconForum size={20} />}>
        <ObjectionList objections={objections} />
      </SalePanel>
      <SalePanel panel={panels.resources} icon={<IconSchool size={20} />}>
        <ResourceList resources={resourceItems} />
      </SalePanel>
      <SalePanel panel={panels.productBrief} icon={<IconInfo size={20} />}>
        <ProductBrief brief={brief} rules={rules} hasRules={hasRules} note={note} />
      </SalePanel>
      <SDModal
        isOpen={resourceModal.isOpen}
        openHandler={closeResource}
        title={resourceModal.title}
        sections={<div dangerouslySetInnerHTML={{ __html: resourceModal.html }} />}
      />
    </PanelStack>
  )
}

export default SalePanels
